import { render, staticRenderFns } from "./controller.vue?vue&type=template&id=99d460d6&scoped=true"
import script from "./controller.vue?vue&type=script&lang=js"
export * from "./controller.vue?vue&type=script&lang=js"
import style0 from "./controller.vue?vue&type=style&index=0&id=99d460d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d460d6",
  null
  
)

export default component.exports